import { useQuery } from "@tanstack/react-query";
import { getCitiesByUf, getUfs } from "../services/api/ibge";
export var useGetUfsQuery = function () {
    return useQuery({
        queryKey: ["get-ufs"],
        queryFn: function () { return getUfs(); },
        select: function (result) {
            return result.data.map(function (uf) { return ({ label: uf.nome, value: uf.sigla }); });
        },
    });
};
export var useGetCitiesByUf = function (uf) {
    return useQuery({
        queryKey: ["get-cities-by-uf", uf],
        queryFn: function () { return getCitiesByUf(uf); },
        select: function (result) {
            if (uf === "MA") {
                return [
                    {
                        label: "Timon",
                        value: "Timon",
                    },
                ];
            }
            return result.data.map(function (city) { return ({
                label: city.nome,
                value: city.nome,
            }); });
        },
        enabled: Boolean(uf),
    });
};
